export const organizationGetKey = (orgId: string | undefined) => ['organization.get', orgId];
